import React, { PureComponent } from 'react';

import { SortDirection } from "../common/interfaces/IPageResponse";
import AgreementsService from "../services/agreements.service";
import {
    AgreementListItem,
    IAgreement,
    IAgreementRequest,
    IAgreementsSortFields,
    IAgreementType
} from "../models/agreements";
import { AuthenticationContext } from "../services/context/authentication.context";
import AgreementSigningModal from 'components/Modals/AgreementSigningModal/AgreementSigningModal';
import AgreementSignaturesModal from 'components/Modals/AgreementSignaturesModal/AgreementSignaturesModal';
import AgreementList from 'components/Agreements/AgreementList';
import { ElectricityAgreement } from 'models/electricity/agreement';
import ElectricityAgreementService from 'services/electricity/electricity-agreement.service';
import { Spinner } from 'react-bootstrap';
import moment from 'moment';
import { isoDateFormat } from 'common/dateFormatterConfig';
import { PageProps } from 'models/page';
import ChargingAgreementService from 'services/charging/charging-agreement.service';
import { ChargingAgreement } from 'models/charging/agreement';


export interface IAgreementsState {
    customerId: number | null;
    oilAgreements: IAgreement[];
    electricityAgreements: ElectricityAgreement[];
    chargingAgreements: ChargingAgreement[];
    pageRequest: IAgreementRequest;
    isAgreementSigningModalOpen: boolean;
    isAgreementSignaturesModalOpen: boolean;
    selectedAgreement: IAgreement | null;
    isRequesting: boolean;
}

export class Agreements extends PureComponent<PageProps, IAgreementsState> {

    static contextType = AuthenticationContext;
    constructor(props: PageProps) {
        super(props);
        this.state = {
            customerId: null,
            oilAgreements: [],
            electricityAgreements: [],
            chargingAgreements: [],
            pageRequest: {
                page: 0,
                size: 500,
                sortDirection: SortDirection.DESC,
                sortField: IAgreementsSortFields.DATE_MODIFIED
            },
            isAgreementSigningModalOpen: false,
            isAgreementSignaturesModalOpen: false,
            selectedAgreement: null,
            isRequesting: false
        };
        this.props.onLoadValidatePage();
    }

    getAgreements = async () => {
        if (this.state.customerId === null)
            return;

        this.setState({ isRequesting: true });

        const [{ content: oilAgreements }, electricityAgreements, chargingAgreements] = await Promise.all([
            AgreementsService.getAgreements(this.state.customerId, this.state.pageRequest),
            ElectricityAgreementService.getElectricityAgreements(this.state.customerId),
            ChargingAgreementService.getAgreements(this.state.customerId)
        ]);

        this.setState({
            oilAgreements,
            electricityAgreements,
            chargingAgreements,
            isRequesting: false
        });
    };

    updateCustomerId = () => {
        if (this.context.state.customerId !== this.state.customerId) {
            this.setState({
                ...this.state,
                customerId: this.context.state.customerId,
                pageRequest: {
                    ...this.state.pageRequest,
                    page: 0
                }
            }, () => {
                this.getAgreements()
            });
        }
    };

    openSigningModal = (agreement: IAgreement) => {
        this.setState({
            isAgreementSigningModalOpen: true,
            selectedAgreement: agreement
        });
    };
    
    openViewSignatures = (agreement: IAgreement) => {
        this.setState({
            isAgreementSignaturesModalOpen: true,
            selectedAgreement: agreement
        });
    };

    onSigningSubmitSuccess = () => {
        this.setState({
            isAgreementSigningModalOpen: false,
            selectedAgreement: null
        });        
        this.getAgreements();
    };

    componentDidMount(): void {
        this.updateCustomerId();
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<IAgreementsState>, snapshot?: any): void {
        this.updateCustomerId();
    }

    getAgreementsList = (): AgreementListItem[] => {
        const agreements: AgreementListItem[] = [];
        this.state.oilAgreements.forEach(a => agreements.push(a));
        this.state.electricityAgreements.forEach(a => agreements.push({ type: IAgreementType.ELECTRICITY, ...a}));
        this.state.chargingAgreements.forEach(a => agreements.push({ type: IAgreementType.CHARGING, ...a}));
        agreements.sort((a, b) => moment(b.dateModified).format(isoDateFormat).localeCompare(moment(a.dateModified).format(isoDateFormat)));
        
        return agreements;
    }

    render() {

        return (
            <div className="agreements__container">
                { this.state.isRequesting ? (
                  <div className='d-flex justify-content-center mt-4'>
                      <Spinner animation="grow" variant="primary" />
                  </div>
                ) : (
                    <AgreementList
                        startSigning={this.openSigningModal}
                        agreements={this.getAgreementsList()}
                    />
                )}
                {
                this.state.isAgreementSigningModalOpen &&
                    <AgreementSigningModal
                        handleModalHide={() => this.setState({ isAgreementSigningModalOpen: false, selectedAgreement: null })}
                        onSubmitSuccess={() => this.onSigningSubmitSuccess()}
                        agreement={this.state.selectedAgreement}
                    />
                }
                {this.state.isAgreementSignaturesModalOpen &&
                    <AgreementSignaturesModal
                        handleModalHide={() => this.setState({ isAgreementSignaturesModalOpen: false, selectedAgreement: null })}
                        agreement={this.state.selectedAgreement}
                    />
                }                
            </div>
        );
    }
}